import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "./AddBooks.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useHistory } from "react-router";
import { CLOUDINARY_CLOUD, SERVER_BASE_URL } from "../../config/config";
import Dropzone, { useDropzone } from "react-dropzone";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Table,
} from "reactstrap";
import { toast } from "react-toastify";
import AppPagination from "helpers/appPagination";

const token = localStorage.getItem("token");
const config = {
  headers: { Authorization: `Bearer ${token}` },
};

function AddTranslators() {
  const history = useHistory();
  const [data, setData] = React.useState({});
  const [text, setText] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [age, setAge] = React.useState("");
  const [dob, setDob] = React.useState("");
  const [authors, setAuthors] = React.useState("");
  const [categories, setCategories] = React.useState([]);
  const [trending, setTrending] = React.useState("");
  const [featured, setFeatured] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [page, setPage] = useState(1);

  const [add, setAdd] = useState("");
  const [edit, setEdit] = useState(false);
  const [imageDelete, setImageDelete] = useState(false);
  const [del, setDel] = useState(false);
  const [currentDeleteId, setCurrentDeleteId] = useState(false);
  const [currentEditAuthor, setCurrentEditAuthor] = useState();
  const [currentEditName, setCurrentEditName] = useState("");
  const [fileNames, setFileNames] = useState([]);
  const [file, setFile] = useState([]);
  const [added, setAdded] = useState(false);
  const [search, setSearch] = useState("");
  const [image, setImage] = React.useState();

  const handleBulkAdd = async (file) => {
    let formData = new FormData();
    formData.append("file", file[0]);

    const precheck = await axios.post(
      `${SERVER_BASE_URL}/v1/app/precheck-translator-bulk`,
      formData,
      config
    );

    await axios.post(
      `${SERVER_BASE_URL}/v1/app/upload-translator-bulk`,
      {
        data: precheck.data.payload,
      },
      config
    );
  };

  const uploadImage = (files) => {
    setImage(files[0]);
  };

  const handleDrop = async (acceptedFiles) => {
    setFile(acceptedFiles);
    setFileNames(acceptedFiles[0].name);
    setAdded(true);
  };

  useEffect(() => {
    setLoading(true);
    getTranslators();
  }, [edit, add, del, search, page]);

  const onEditClick = (data) => {
    setEdit(true);
    setCurrentEditAuthor(data);
  };

  const onDeleteClick = (id) => {
    setDel(true);
    setCurrentDeleteId(id);
    handleDeleteClick(id);
  };

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  const handleCancelEdit = (e) => {
    e.preventDefault();
    setEdit(false);
    setData({});
  };

  const getTranslators = () => {
    axios
      .get(
        `${SERVER_BASE_URL}/v1/app/translators?paginate=true&page=${page}&search=${search}&sortBy=name:asc`,
        config
      )
      .then((res) => {
        setAuthors(res.data.payload);
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Unable to Get Translators!");
        setLoading(false);
      });
  };

  const handleInputChange = (e, type, name) => {
    let obj = data;
    obj = { ...obj, [e.target.name]: e.target.value };
    setData(obj);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(data);

    const fd = new FormData();
    fd.append("file", image);

    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        data[key].forEach((d) => fd.append(key, d));
        return;
      }
      fd.append(key, data[key]);
    });

    await axios
      .post(`${SERVER_BASE_URL}/v1/app/add-translator`, fd, config)
      .then((res) => {
        setAdd(res);
        toast.success("Success!");
        setData("");
      })
      .catch((err) => toast.error("Unable to Add Translator!"));
    setImage();

    setData({});
  };

  const handleEditAuthor = async (e, id) => {
    e.preventDefault();

    const fd = new FormData();

    if (image) {
      fd.append("file", image);
    }

    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        data[key].forEach((d) => fd.append(key, d));
        return;
      }
      fd.append(key, data[key]);
    });

    await axios
      .patch(`${SERVER_BASE_URL}/v1/app/translator/${id}`, fd, config)
      .then(() => {
        toast.success("Success!");
      })
      .catch((err) => toast.error("Unable to Edit Translator!"));
    setImage();

    setData({});
    setEdit(false);
  };

  const handleDeleteClick = async (id) => {
    console.log(id);
    await axios
      .post(`${SERVER_BASE_URL}/v1/app/translator/${id}`, {}, config)
      .then(() => {
        toast.success("Deleted!");
      })
      .catch((err) => toast.error("Unable to Delete Translator!"));
    setDel(false);
  };

  const onImageDelete = async (event, image, id) => {
    event.preventDefault();
    console.log(id);
    await axios
      .patch(
        `${SERVER_BASE_URL}/v1/app/translator/image/${id}`,
        {
          image,
        },
        config
      )
      .then(() => {
        toast.success("Deleted!");
      })
      .catch((err) => toast.error("Unable to Delete Translator Image!"));
    setImageDelete(true);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">Add Translator</CardTitle>
              </CardHeader>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col className="pr-1" md="3">
                      <FormGroup>
                        <label>Name</label>
                        <Input
                          placeholder="Translator Name"
                          type="text"
                          name="name"
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pr-1" md="3">
                      <FormGroup>
                        <label>Name in English</label>
                        <Input
                          placeholder="Translator Name in English"
                          type="text"
                          name="en"
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pr-1" md="3">
                      <FormGroup>
                        <label>Age</label>
                        <Input
                          placeholder="Age"
                          type="text"
                          name="age"
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col className="pr-1" md="3">
                      {" "}
                      <FormGroup>
                        <label for="file">Choose a file</label>
                        <Input
                          type="file"
                          id="file"
                          class="inputfile"
                          name="image"
                          onChange={(e) => uploadImage(e.target.files)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <div className="update ml-auto mr-auto">
                      <Button
                        className="btn-round"
                        color="primary"
                        type="submit"
                      >
                        Add Translator
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>{" "}
          {edit && (
            <Col md="12">
              <Card className="card-user">
                <CardHeader>
                  <CardTitle tag="h5">Edit {currentEditAuthor?.name}</CardTitle>
                </CardHeader>
                <CardBody>
                  <form
                    onSubmit={(e) => handleEditAuthor(e, currentEditAuthor?.id)}
                  >
                    <Row>
                      <Col className="pr-1" md="5">
                        <FormGroup>
                          <label>Name</label>
                          <Input
                            placeholder="Author Name"
                            type="text"
                            name="name"
                            defaultValue={currentEditAuthor?.name}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="5">
                        <FormGroup>
                          <label>Age</label>
                          <Input
                            placeholder="Age"
                            type="text"
                            name="age"
                            defaultValue={currentEditAuthor?.age}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="4">
                        <FormGroup>
                          <label for="file">Choose a file</label>
                          <Input
                            type="file"
                            id="file"
                            class="inputfile"
                            name="image"
                            onChange={(e) => uploadImage(e.target.files)}
                          />
                        </FormGroup>
                        <br></br>
                        <div>Current Image:</div>
                        <img
                          width="120"
                          src={!imageDelete ? currentEditAuthor?.image : ""}
                        ></img>
                      </Col>
                    </Row>
                    <br></br>
                    <button
                      onClick={(e) =>
                        onImageDelete(
                          e,
                          currentEditAuthor?.image,
                          currentEditAuthor?.id
                        )
                      }
                    >
                      X Delete Image
                    </button>

                    <Row>
                      <div className="update ml-auto mr-auto">
                        <Button
                          className="btn-round"
                          color="primary"
                          type="submit"
                        >
                          Edit Translator
                        </Button>
                      </div>
                      <div className="update ml-auto mr-auto">
                        <Button
                          className="btn-round"
                          color="primary"
                          type="button"
                          onClick={(e) => handleCancelEdit(e)}
                        >
                          Cancel Edit
                        </Button>
                      </div>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          )}{" "}
          <Col md="12">
            {" "}
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">Bulk Add Translators</CardTitle>
              </CardHeader>
              <Dropzone
                onDrop={handleDrop}
                accept="image/*"
                minSize={1024}
                maxSize={3072000}
              >
                {({
                  getRootProps,
                  getInputProps,
                  isDragActive,
                  isDragAccept,
                  isDragReject,
                }) => {
                  const additionalClass = isDragAccept
                    ? "accept"
                    : isDragReject
                    ? "reject"
                    : "";

                  return (
                    <div
                      {...getRootProps({
                        className: `dropzone ${additionalClass}`,
                      })}
                    >
                      <input {...getInputProps()} />
                      <span>{isDragActive ? "📂" : "📁"}</span>
                      {added
                        ? fileNames
                        : "Drag'n'drop images, or click to select files"}
                    </div>
                  );
                }}
              </Dropzone>
              <Row>
                <div className="update ml-auto mr-auto">
                  <Button
                    onClick={() => handleBulkAdd(file)}
                    className="btn-round"
                    color="primary"
                    type="submit"
                  >
                    Bulk Add
                  </Button>
                </div>
              </Row>
            </Card>
          </Col>
          <Col md="12">
            <Card style={{ minHeight: "700px" }}>
              <CardHeader>
                <CardTitle tag="h4">Translators Database</CardTitle>
                <input
                  id="search"
                  name="search"
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                  required
                />
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Name</th>
                      <th>ID</th>
                      <th>Age</th>
                      <th>No. of notebooks</th>
                      <th className=""></th>
                    </tr>
                  </thead>
                  <tbody style={{ minHeight: "550px" }}>
                    {!loading
                      ? authors?.results?.map((author) => (
                          <tr>
                            <td>
                              {" "}
                              <div
                                style={{ cursor: "pointer", color: "#51cbce" }}
                                onClick={() => onEditClick(author)}
                              >
                                {author?.name}
                              </div>
                            </td>
                            <CopyToClipboard
                              text={author?.id}
                              onCopy={onCopyText}
                            >
                              <td
                                onChange={(event) =>
                                  setText(event.target.value)
                                }
                              >
                                <div
                                  style={{
                                    cursor: "pointer",
                                    color: "#51cbce",
                                  }}
                                >
                                  {author?.id}{" "}
                                </div>
                              </td>
                            </CopyToClipboard>
                            <td>{author?.age}</td>
                            <td>{author?.noOfBooks ? author?.noOfBooks : 0}</td>
                            <td>
                              <div
                                style={{ cursor: "pointer", color: "#51cbce" }}
                                onClick={() => onDeleteClick(author?.id)}
                              >
                                Delete
                              </div>
                            </td>
                          </tr>
                        ))
                      : "Loading..."}
                  </tbody>
                </Table>
              </CardBody>
              <AppPagination setPage={setPage} {...authors} />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default AddTranslators;
